<template>
    <div class="container mt-0">
        <div class="wrapper">
            
            <div class="row pt-5 pb-5">

                <div class="login-window d-flex">

                    <div v-if="loading" class="loading"></div>
                        <div class="slider reasonbg p-3">
                            <h2 class="text-center pb-5"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                            <ul class="row">
                                <li class="col-md-6 text-center">
                                    <i class="reason-icon reason-1"></i>
                                    <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                                </li>
                                <li class="col-md-6 text-center">
                                    <i class="reason-icon reason-4"></i>
                                    <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                                </li>
                                <li class="col-md-6 text-center">
                                    <i class="reason-icon reason-2"></i>
                                    <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                                </li>
                                <li class="col-md-6 text-center">
                                    <i class="reason-icon reason-3"></i>
                                    <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>                                    
                                </li>
                                <li class="col-md-12 text-center">
                                    <i class="reason-icon reason-5"></i>
                                    <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                                </li>
                            </ul>
                        </div>

                        <div class="login-form">
                    
                            <h1>{{ $t('Reset Password') }}</h1>

                            <form class="w-100" @submit.prevent="onSubmit" novalidate>
                                <div v-if="loading" class="loader"></div>

                                <div v-if="isShow">
                                    <bootstrap-alert 
                                        :variant="response.variant" 
                                        :msg="response.message" 
                                        :errorMsg="response.errmsg" 
                                    />
                                </div>
                                <div class="form-group">
                                    <label for="email">
                                    {{ $t('Email Address') }}
                                    <span class="required">*</span>
                                    </label>
                                    <input 
                                        type="email" 
                                        class="form-control input-field" 
                                        id="email" 
                                        v-model="form.email" 
                                        autocomplete="off"
                                        name="email" 
                                        :placeholder="$t('Email')" />
                                </div>

                                <captcha :form="form"></captcha>

                                <input 
                                    type="submit" 
                                    class="btn btn-primary d-block w-100 login-button bg-black mb-4" 
                                    :value="$t('Submit')" />
                            </form>
                                    
                        </div>
                </div>
            
            </div>

        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Captcha from '../components/Captcha'

export default {
    metaInfo: {
        title: 'Reset Password Link',
        meta: [
            {name: 'description', content: 'This is reset password link page'}
        ],
        link: [
            {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'resetpassword'}
        ]
    },
    components:{
        Captcha
    },
    data() {
        return {
            errors: [],
            form: {
                email: '',
            },
            show: true
        }
    },
    computed: {
        ...mapGetters('resetpassword', ['response', 'isShow', 'loading']),
        ...mapGetters('app', ['currentLang'])
    },
    created() {       
    },
    methods: {
        ...mapActions('resetpassword', ['setIsShow', 'sendResetPasswordLink', 'showError', 'resetError']),
        async onSubmit() {
            this.setIsShow(false)
            var setflag = true;
            this.errors = [];

            if (this.form.email == '') {
                setflag = false;
                this.errors.push([this.$t('Email is required.')]);
            } else {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                var valid = regex.test(this.form.email);
                if (!valid) {
                    setflag = false;
                    this.errors.push([this.$t('Email is not valid.')]);
                }
            }
    
            if(setflag) {
                this.resetError();
                    this.sendResetPasswordLink(this.form)
                    .then((response) => {
                        this.setIsShow(false)
                        this.form.email = "";
                        this.flash(this.$t('You will receive password reset link if we find matching record in our database'), 'success',{
                            timeout: 10000
                        })

                        this.$router.push({ name: 'login', replace: true }).catch(err => {});
                    })
                    .catch((error) => {
                        this.response.message = "";
                        this.response.variant = 'danger';
                        this.response.errmsg = (error.response.data.errors) ? error.response.data.errors : error.response.data;
                    });               
            } else {
                this.showError({'msg': '', 'errors': this.errors});
            }
            
        }
    },
    destroyed(){
        // this.setIsShow(false)
    }
};
</script>